const ReducerData = (state, action) => {
    switch (action.type) {
        case "FETCH_ANSWERS": 
            return{
                ...state,
                contextUserAnswers: action.payload
            } 
        case "FETCH_CURRENT": 
            return{
                ...state,
                contextCurrentQuestion: action.payload
            }  

        default:
            return state
    }
}

export default ReducerData